export default __webpack_public_path__ + "static/media/Jean-Michel Basquiat_s _Warrior_- Living_Up_to_Expectations.4b33a9e1.pdf";